/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app/app.component';
import { CoreModule } from './app/core/core.module';
import { AppRoutingModule } from './app/app-routing.module';

import { environment } from './environments/environment';

import {
  MsalModule,
  MsalGuard,
  MsalInterceptor,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration
} from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

// ---- MSAL config
const guardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: { scopes: ['openid', 'profile', 'email', ...environment.api.scopes] }
};

console.log('### ACTIVE ENV ###', environment.envName);

function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map<string, string[]>([
      [environment.api.baseUrl + '*', environment.api.scopes]
    ])
  };
}

const pca = new PublicClientApplication({
  auth: {
    clientId: environment.azureAd.clientId,
    authority: environment.azureAd.authority,
    redirectUri: environment.azureAd.redirectUri,
    postLogoutRedirectUri: environment.azureAd.postLogoutRedirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: { cacheLocation: 'localStorage', storeAuthStateInCookie: true }
});

function initMsal() {
  return async () => {
    // 1️ Initialize MSAL
    await pca.initialize();

    // 2️ Handle redirect results (login / acquire token)
    await pca.handleRedirectPromise();

    // 3️ Ensure an active account is set (this is your snippet)
    const accounts = pca.getAllAccounts();
    if (accounts.length > 0 && !pca.getActiveAccount()) pca.setActiveAccount(accounts[0]);
  };
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      CoreModule,
      AppRoutingModule,
      //MsalModule.forRoot(pca, guardConfig, interceptorConfig)
      MsalModule.forRoot(pca, guardConfig, msalInterceptorConfigFactory())
    ),
    { provide: APP_INITIALIZER, useFactory: initMsal, multi: true },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    MsalGuard,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true }
  ]
}).catch(err => console.error(err));
